export default __webpack_public_path__ + "static/media/Inventario.1d9be58c.svg";